
'use client';

import dynamic from 'next/dynamic';
import { Skeleton } from '@/components/ui/skeleton';

const IotDashboard = dynamic(() => import('@/components/sections/iot-dashboard').then(mod => mod.IotDashboard), {
    ssr: false,
    loading: () => <Skeleton className="h-[400px] w-full" />,
});

const SmartRetailDashboard = dynamic(() => import('@/components/sections/smart-retail-dashboard').then(mod => mod.SmartRetailDashboard), {
    ssr: false,
    loading: () => <Skeleton className="h-[400px] w-full" />,
});

const FleetManagementDashboard = dynamic(() => import('@/components/sections/fleet-management-dashboard').then(mod => mod.FleetManagementDashboard), {
    ssr: false,
    loading: () => <Skeleton className="h-[400px] w-full" />,
});

const SmartAgricultureDashboard = dynamic(() => import('@/components/sections/smart-agriculture-dashboard').then(mod => mod.SmartAgricultureDashboard), {
    ssr: false,
    loading: () => <Skeleton className="h-[400px] w-full" />,
});


export function IotDemosClient() {
    return (
        <>
            <IotDashboard />
            <SmartRetailDashboard />
            <FleetManagementDashboard/>
            <SmartAgricultureDashboard/>
        </>
    )
}
